import { useParams } from 'react-router-dom';
export const useAnalyticsReport = () => {
    const { reportId } = useParams();
    return {
        title: `Report ${reportId}`,
        reportId,
    };
};
